import { RouterProvider } from '@tanstack/react-router';

import { SteadoLoader } from '@/components/shell/SteadoLoader';
import { useAuth } from '@/lib/auth/auth-context';
import { LoginScreen } from '@/screens/LoginScreen';

import { router } from './router';

/**
 * The console's front door.
 *
 * Authentication gates the whole router rather than each route: there is no
 * screen here that an unauthenticated operator should reach, so a single gate
 * is both simpler and impossible to forget on a new route.
 */
export function AuthGate() {
  const { status } = useAuth();

  if (status === 'restoring') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <span role="status" className="flex flex-col items-center gap-3 text-[13px] text-muted-foreground">
          <SteadoLoader className="size-9 text-primary" />
          Restoring session…
        </span>
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <LoginScreen />;
  }

  return <RouterProvider router={router} />;
}
